import { memo, ReactElement } from 'react';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { ESportsbookLayoutTypes } from 'interfaces/sportsbook-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import './index.less';

type TProps = {
  isLive?: boolean;
  withBack?: boolean;
  showMarketFilterSkeleton?: boolean;
  applyAdditionalMargin?: boolean;
  showSportNameWithFavorite?: boolean;
};

export const SportsbookGameListHeaderSkeleton = memo(
  ({
    isLive = false,
    withBack = false,
    showMarketFilterSkeleton = true,
    applyAdditionalMargin = false,
    showSportNameWithFavorite
  }: TProps): ReactElement => {
    const configs = useSportsbookConfigs();
    const { params } = useSbRouteMatch();

    return (
      <div className="sportsbook-game-list-skeleton">
        {showSportNameWithFavorite && (
          <div className="sportsbook-game-list-skeleton__header sportsbook-game-list-skeleton__header-mobile sportsbook-game-list-skeleton__header-mobile-back">
            <div className="sportsbook-game-list-skeleton__header--markets-filter">
              <Skeleton.Button
                style={{
                  width: '150px !important',
                  minWidth: 'unset',
                  marginTop: '6px',
                  height: '20px'
                }}
                active
                applyElementStyle={false}
              />
              <span className="sportsbook-game-list-skeleton__header--title sportsbook-game-list-skeleton__header--title-mobile"></span>
            </div>
          </div>
        )}
        {isMobile() && withBack ? (
          <div className="sportsbook-game-list-skeleton__header sportsbook-game-list-skeleton__header-mobile sportsbook-game-list-skeleton__header-mobile-back">
            <div className="sportsbook-game-list-skeleton__header--expand-all">
              <Skeleton.Button active applyElementStyle={false} />
              <span className="sportsbook-game-list-skeleton__header--title sportsbook-game-list-skeleton__header--title-mobile"></span>
            </div>
            <div className="sportsbook-game-list-skeleton__header--markets-filter">
              <Skeleton.Button active applyElementStyle={false} />
              <span className="sportsbook-game-list-skeleton__header--title sportsbook-game-list-skeleton__header--title-mobile"></span>
            </div>
          </div>
        ) : null}

        <div
          className={cc([
            'sportsbook-game-list-skeleton__header',
            {
              'sportsbook-game-list-skeleton__header-mobile': isMobile(),
              'sportsbook-game-list-skeleton__header--withoutMarketsFilter':
                !showMarketFilterSkeleton &&
                configs.spbLayoutType !== ESportsbookLayoutTypes.AMERICAN,
              'sportsbook-game-list-skeleton__header--additionalMargin':
                applyAdditionalMargin
            }
          ])}
        >
          {showMarketFilterSkeleton && (
            <span
              className={cc([
                'sportsbook-game-list-skeleton__header--title',
                {
                  'sportsbook-game-list-skeleton__header--title-mobile':
                    isMobile()
                }
              ])}
            >
              <Skeleton.Button
                active
                applyElementStyle={false}
                style={
                  !isLive && isMobile()
                    ? { height: '20px', width: '140px' }
                    : {}
                }
              />
            </span>
          )}

          <div className="headerRightSkeletonWrapper">
            {showMarketFilterSkeleton && (isMobile() ? !isLive : false) && (
              <span className="sportsbook-game-list-skeleton__header--markets-filter">
                <Skeleton.Button active applyElementStyle={false} />
              </span>
            )}

            {(!isMobile() || isLive) && (
              <>
                <span className="sortingBtn sortingBtn-skeleton">
                  <Skeleton.Button active applyElementStyle={false} />
                </span>
                <span className="sortingBtn sortingBtn-skeleton">
                  <Skeleton.Button active applyElementStyle={false} />
                </span>
              </>
            )}
          </div>
        </div>

        {isMobile() && !isLive && !withBack && (
          <div className="sportsbook-game-list-skeleton__sub-header">
            <div className="sportsbook-game-list-wrapper__sub-header-left">
              <div className="sportsbook-game-list-skeleton__sub-header--title">
                {!params.competition ? (
                  <Skeleton.Button active />
                ) : (
                  <div className="sportsbook-game-list-skeleton__sub-header--competition">
                    <Skeleton.Avatar active style={{ width: 12, height: 12 }} />
                    <Skeleton.Avatar active style={{ width: 24, height: 24 }} />
                    <Skeleton.Button
                      active
                      style={{ width: 100, height: 20 }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="sportsbook__icons">
              <span className="sortingBtn sortingBtn-skeleton">
                <Skeleton.Button active applyElementStyle={false} />
              </span>
              <span className="sportsbook-game-list-skeleton__header--expand-all">
                <Skeleton.Button active applyElementStyle={false} />
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
);
